import { Toaster as SonnerToaster } from "sonner";
import { CircleCheckBig, CircleX, Info, TriangleAlert, Loader2 } from "lucide-react";

const iconClass = "h-[18px] w-[18px]";

export function Toaster() {
  return (
    <SonnerToaster
      position="top-center"
      closeButton={false}
      duration={5000}
      visibleToasts={5}
      gap={8}
      style={{ "--width": "420px" } as React.CSSProperties}
      icons={{
        success: <CircleCheckBig className={iconClass} strokeWidth={1.8} />,
        error: <CircleX className={iconClass} strokeWidth={1.8} />,
        info: <Info className={iconClass} strokeWidth={1.8} />,
        warning: <TriangleAlert className={iconClass} strokeWidth={1.8} />,
        loading: (
          <Loader2 className={`${iconClass} animate-spin`} strokeWidth={1.8} />
        ),
      }}
      toastOptions={{
        classNames: {
          // Type-based color is scoped with data-[type=...] variants (all in
          // this one class) rather than sonner's separate success/error/etc
          // classNames keys, since those are appended *alongside* `default`
          // on the same element — two same-specificity utility classes both
          // setting color/before:bg would race on stylesheet order instead
          // of reliably picking the typed one.
          toast:
            "font-archivo !max-w-[calc(100vw-40px)] !items-start !bg-[#1E1B4B] !border !border-white/10 !rounded-[3px] !shadow-[0_10px_28px_rgba(14,12,36,0.28)] !p-0 relative overflow-hidden " +
            "!text-[#A78BFA] before:content-[''] before:absolute before:inset-x-0 before:bottom-0 before:h-[2px] before:origin-left before:animate-toast-progress before:bg-[#8B6BF0] " +
            "data-[type=success]:!text-[#4ADE80] data-[type=success]:before:bg-[#4ADE80] " +
            "data-[type=error]:!text-[#FCA5A5] data-[type=error]:before:bg-[#F87171] " +
            "data-[type=warning]:!text-[#E9B949] data-[type=warning]:before:bg-[#E9B949] " +
            "data-[type=info]:!text-[#A78BFA] data-[type=info]:before:bg-[#8B6BF0] " +
            "data-[type=loading]:!text-[#C9C5E8] data-[type=loading]:before:w-full data-[type=loading]:before:animate-none",
          icon: "!mt-[15px] !ml-[18px]",
          content: "!flex-1 !py-4 !pr-[18px] !pl-2.5 !text-left",
          title: "!font-archivo !font-semibold !text-[14px] !leading-[1.4] !text-white",
          description:
            "!font-archivo !text-[13px] !leading-[1.4] !text-white/70",
        },
      }}
    />
  );
}
